export const painWorstOptions = [
  'Morning',
  'Afternoon',
  'Evening',
  'While walking',
  'While exercising',
  'While standing',
  'While sitting',
  'While laying in bed',
  'Getting out of bed or chair',
  'Always problematic',
  'Comes and goes randomly',
  'Other',
];
